import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#11a193', // Green color matching the image
    },
  },
});

export default theme;
